/**
 * Display-name helpers for the reports surface (AUT-127). Mirrors the
 * inspectors / orders / users versions — kept page-local so the reports
 * page never imports across sibling vertical boundaries.
 *
 * The server sends `inspectorName` / `customerName` already
 * redacted-or-full per `piiRevealed`. These helpers only derive avatar
 * initials + a short id from values the SPA already holds — they never
 * reconstruct PII. Cyrillic-aware so the initials of "Мария Ковалёва"
 * render as "МК", not "MK".
 */

/** Two-letter avatar initials from a display name; '—' fallback. */
export const initials = (name: string | null): string => {
  if (!name) return '—';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '—';
  const second = parts[1];
  if (!second) return first.slice(0, 2).toLocaleUpperCase();
  return ((first[0] ?? '') + (second[0] ?? '')).toLocaleUpperCase();
};

/** Truncate a report id to the mockup's `rep_5f1a…b80` shape. */
export const shortId = (id: string): string => {
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};

/**
 * Header avatar tag derived from `reportNumber` — the mockup renders
 * `R-3092` in a square rounded avatar at 52×52px. We return the
 * sanitised display string ("R-3092"); if no number is set we fall
 * back to "RPT".
 */
export const reportTag = (reportNumber: string | null | undefined): string => {
  if (!reportNumber || reportNumber.length === 0) return 'RPT';
  return reportNumber;
};
